module.exports = __webpack_public_path__ + "media/images/lb/846-a90e85d8b17506ba62cef2cc9525b196.svg";